import { useMap } from '@vis.gl/react-maplibre';
import type { MapLayerEventType } from 'maplibre-gl';
import { useEffect } from 'react';

interface UseMapLayerOnEventProps<T extends keyof MapLayerEventType> {
  type: T;
  layer: string;
  listener: (event: MapLayerEventType[T] & object) => void;
  enabled?: boolean;
  mapId?: string;
}

export const useMapLayerOnEvent = <T extends keyof MapLayerEventType>({
  type,
  layer,
  listener,
  enabled = true,
  mapId = 'current',
}: UseMapLayerOnEventProps<T>) => {
  const mapRef = useMap();

  useEffect(() => {
    const map = mapRef[mapId];

    if (enabled) {
      map?.on(type, layer, listener);

      return () => {
        map?.off(type, layer, listener);
      };
    }

    return () => {};
  }, [enabled, layer, listener, mapId, mapRef, type]);
};
